import CrudBase from "src/components/CrudBase";
import { useTranslation } from "react-i18next";
import UsersForm from "./UsersForm";
import User from "src/models/user";
import AccountBoxIcon from '@mui/icons-material/AccountBox';

export function Users() {
  const { t } = useTranslation();

  return (
    <CrudBase<User>
      resource="users"
      indexColumns={['name', 'email', 'role']}
      indexCustomColumns={(user) => ({
        role: user.role.name,
      })}
      showCustomColumns={(user) => ({
        role: <b>{user.role.name}</b>,
        active: <b>{t('USERS.ACTIVE.' + user.active)}</b>
      })}
      Form={UsersForm}
      showModalColumns={['name','email','role','created_at','updated_at']}
      searchInput={true}
      deleteButton={false}
      Icon={AccountBoxIcon}
    />
  );
}
